var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Pagebody',{staticStyle:{"margin":"0 auto","float":"none"},attrs:{"loading":false}},[_c('div',{staticStyle:{"height":"100px"}}),_c('div',{staticClass:"backImg"}),_c('h1',{staticClass:"transfer_title"},[_vm._v("订单支付成功，"),_c('span',[_vm._v(_vm._s(_vm.sec))]),_vm._v("秒后将关闭页面。")]),_c('div',{staticStyle:{"height":"250px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }